export const UomMap: Record<string, string> = {
  BAG: 'Bags',
  BAL: 'Bale',
  BDL: 'Bundles',
  BKL: 'Buckles',
  BOU: 'Billion of units',
  BOX: 'Box',
  BTL: 'Bottles',
  BUN: 'Bunches',
  CAN: 'Cans',
  CBM: 'Cubic metres',
  CCM: 'Cubic centimetres',
  CMS: 'Centimetres',
  CTN: 'Cartons',
  DOZ: 'Dozens',
  DRM: 'Drums',
  GGK: 'Great gross',
  GMS: 'Grammes',
  GRS: 'Gross',
  GYD: 'Gross yards',
  KGS: 'Kilograms',
  KLR: 'Kilolitre',
  KME: 'Kilometre',
  LTR: 'Litres',
  MLT: 'Millilitre',
  MTR: 'Metres',
  MTS: 'Metric ton',
  NOS: 'Numbers',
  OTH: 'Others',
  PAC: 'Packs',
  PCK: 'Packed',
  PCS: 'Pieces',
  PRS: 'Pairs',
  QTL: 'Quintal',
  ROL: 'Rolls',
  SET: 'Sets',
  SQF: 'Square feet',
  SQM: 'Square metres',
  SQY: 'Square yards',
  TBS: 'Tablets',
  TGM: 'Ten gross',
  THD: 'Thousands',
  TON: 'Tonnes',
  TUB: 'Tubes',
  UGS: 'US gallons',
  UNT: 'Units',
  YDS: 'Yards',
};
